import React, { useRef } from 'react'; import { DoubleSide } from 'three';
import { useGLTF } from '@react-three/drei'

export function AnK(props) {
    const group = useRef();
    const { nodes } = useGLTF('3ds/an/AnK.gltf');
    return (
        <group ref={group} {...props} dispose={null}>
            <mesh
                name="AnK"
                geometry={nodes.AnK.geometry}
                rotation={[Math.PI / 2, 0, 0]}
                {...props.meshProps}
            />
        </group>
    );
}

useGLTF.preload('3ds/an/AnK.gltf')